export default "__VITE_ASSET__CUrHiVlB__"